import {
  generatePageNameForMixpanelBasedOnOurRoutes,
  useTrackEvent,
} from '@/mixpanel/useTrackEvent'
import { customFonts, FontPicker, useNotifications } from '@valuecase/ui-components'
import { useCallback, useEffect, useState } from 'react'
import { useCurrentLocation } from '../navigation/hooks/useCurrentLocation'
import { useCompanyVisualSettings } from './hooks/useCompanyVisualSettings'
import { SettingsInfo } from './SettingsInfo'

export const FontSetting = () => {
  const { success } = useNotifications()
  const { companySettings, updateCompanySettings } = useCompanyVisualSettings({
    onUpdateSuccess: () => {
      success('Font style updated successfully')
    },
  })
  const { trackEvent } = useTrackEvent()
  const currentLocation = useCurrentLocation()

  const [selectedFontFamily, setSelectedFontFamily] = useState<(typeof customFonts)[number] | null>(
    null,
  )

  useEffect(() => {
    if (companySettings) {
      setSelectedFontFamily(companySettings?.fontFamily || null)
    }
  }, [companySettings, companySettings?.fontFamily, selectedFontFamily])

  const handleFontChange = useCallback(
    async (
      newValue:
        | {
            fontFamily: null
          }
        | {
            fontFamily: (typeof customFonts)[number]
            fontFamilySpec: string
          },
    ) => {
      if (newValue.fontFamily !== null) {
        updateCompanySettings({
          fontFamily: newValue.fontFamily,
          fontFamilySpec: newValue.fontFamilySpec,
        })
      } else {
        updateCompanySettings({
          fontFamily: null,
        })
      }
      trackEvent({
        event: 'font-changed',
        eventProperties: {
          fontFamily: newValue.fontFamily ?? null,
          indexPageName: generatePageNameForMixpanelBasedOnOurRoutes(currentLocation),
        },
      })
    },
    [trackEvent, currentLocation, updateCompanySettings],
  )

  return (
    <div className='flex justify-between w-full items-start'>
      <div className={'flex flex-col gap-2'}>
        <SettingsInfo
          title='Font Style'
          description='Select the typeface that will be used in your spaces. '
        />
      </div>
      <div className='relative flex flex-col gap-2 items-end'>
        <FontPicker
          className={'w-44'}
          value={
            companySettings?.customHostedFont?.fontFamily
              ? companySettings?.customHostedFont.fontFamily
              : selectedFontFamily
          }
          onValueChange={handleFontChange}
          disabled={!!companySettings?.customHostedFont?.fontFamily}
        />
      </div>
    </div>
  )
}
